// Shared marketing CTA targets. One definition so the nav, hero, and close
// sections can never drift apart.
export const SIGN_IN_HREF = '/sign-in'
export const BOOK_A_DEMO_HREF = 'https://legix.typeform.com/discover?typeform-source=www.legix.ai'
